"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = void 0;
const malty_atoms_progress_spinner_1 = require("@carlsberggroup/malty.atoms.progress-spinner");
const malty_atoms_text_1 = require("@carlsberggroup/malty.atoms.text");
const malty_theme_malty_theme_provider_1 = require("@carlsberggroup/malty.theme.malty-theme-provider");
const react_1 = __importStar(require("react"));
const Loading_styled_1 = require("./Loading.styled");
const Loading_types_1 = require("./Loading.types");
const Loading = ({ text, size = Loading_types_1.LoadingSize.Small, status = Loading_types_1.LoadingStatus.Pending, dataQaId, negative = false, color = malty_atoms_progress_spinner_1.ProgressSpinnerColor.DigitalBlack }) => {
    const theme = malty_theme_malty_theme_provider_1.globalTheme;
    const [progressStatus, setProgressStatus] = (0, react_1.useState)(malty_atoms_progress_spinner_1.ProgressSpinnerStatus.Pending);
    const [iconSize, setIconSize] = (0, react_1.useState)(theme.sizes.m.value);
    (0, react_1.useEffect)(() => {
        switch (size) {
            case Loading_types_1.LoadingSize.Medium: {
                setIconSize(theme.sizes['2xl'].value);
                break;
            }
            default: {
                setIconSize(theme.sizes.m.value);
                break;
            }
        }
    }, [size, theme]);
    (0, react_1.useEffect)(() => {
        switch (status) {
            case Loading_types_1.LoadingStatus.Success: {
                setProgressStatus(malty_atoms_progress_spinner_1.ProgressSpinnerStatus.Success);
                break;
            }
            case Loading_types_1.LoadingStatus.Failure: {
                setProgressStatus(malty_atoms_progress_spinner_1.ProgressSpinnerStatus.Failure);
                break;
            }
            default: {
                setProgressStatus(malty_atoms_progress_spinner_1.ProgressSpinnerStatus.Pending);
                break;
            }
        }
    }, [status]);
    return status ? (react_1.default.createElement(Loading_styled_1.StyledLoadingContainer, { "data-testid": `${dataQaId}`, size: size, theme: theme },
        react_1.default.createElement(Loading_styled_1.StyledLoading, { size: iconSize, className: `${status === Loading_types_1.LoadingStatus.Pending ? 'spinning' : 'fade-in'} ${status}` },
            react_1.default.createElement(malty_atoms_progress_spinner_1.ProgressSpinner, { color: color, negative: negative, dataQaId: `${dataQaId}`, status: progressStatus })),
        text && (react_1.default.createElement(malty_atoms_text_1.Text, { dataQaId: `${dataQaId}-label`, textStyle: malty_atoms_text_1.TextStyle.SmallBold, color: malty_atoms_text_1.TextColor.Support60 }, text)))) : null;
};
exports.Loading = Loading;
//# sourceMappingURL=Loading.js.map